let registerPromise = null;

export function registerSwiper() {
    if (!registerPromise) {
        registerPromise = import('swiper/element/bundle').then(({ register }) => {
            register();
        });
    }
    return registerPromise;
}
